/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import CircularLoading from "../../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { FirebaseContext } from "common";
import GridContainer from "components/Grid/GridContainer.js";
import TableRowsOutlinedIcon from '@mui/icons-material/TableRowsOutlined';
import GoogleMapsAutoComplete from "../../components/GoogleMapsAutoComplete";
import { AddBoxRounded } from "@material-ui/icons";
import { language } from "config";
import { features } from "config";
import { Grid, Paper, Typography } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.js";
//import { colors } from "../../../../common/theme";
import {
  Row,
  Col,
  Label,
  CardBody,
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  Input,
  FormText,
  Button,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import {
  StyleSheet,

  View,
  Image,
  Dimensions,
  TouchableOpacity,
} from "react";
import { TextField, FormControl, Select } from "@material-ui/core";
import FlatList from "flatlist-react";
import { makeStyles } from "@material-ui/core";
import { useNavigate, useLocation } from "react-router-dom";
import { setDefaultLocale } from "react-datepicker";

import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

const StaffEnquiries = () => {
  const { api } = useContext(FirebaseContext);
  const {
    CreateEnquiry,
    fetchCoordsfromPlace,
  } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const [equiries, setEquiries] = useState([]);
  const [isFiltered, setisFiltered] = useState(false);
  const enquiriesReducer = useSelector((state) => state.enquirydata.enquiries);
  const [isOpen, setIsOpen] = useState(false);


  const [isCardView, setIsCardView] = useState(true)

  const toggleTwo = () => setIsOpen(!isOpen);
  const navigate = useNavigate();

  useEffect(() => {
    if (enquiriesReducer) {
      console.log("Enquiries", enquiriesReducer);

      setEquiries(enquiriesReducer);
    }
  }, [enquiriesReducer]);

  const useStyles = makeStyles({
    root: {
      minWidth: 275,
      border: "5px solid",
      borderColor: "#399ddb",
      // borderBlockStartColor: "#ff0000",
      // borderBlockStart: "2px solid",
      // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
      flexDirection: "column",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
    },
    Button: {
      width: 150,
      height: 40,
    },
    ImgContainer: {
      borderRadius: '50',
      height: "75%",
      width: "100%",
      aspectRatio: '16/9',
    },
    Card: {
      width: "50%",
      padding: 10,
      minWidth: 275,
      border: "1px solid",
      borderColor: "#399ddb",
      borderRadius: 30,
    },
    ImgCard: {
      width: "90%",
      border: "1px solid",
      borderColor: "#399ddb",
      borderRadius: 30,
    },
    PriceText: { margin: "20px0 15px", color: "#FF0000", fontSize: 32 },
    propType: {
      margin: "20px0 15px",
      fontSize: 16,
      color: "grey"
    },
    detialsSmokey: { width: "100%", alignContent: "center", flexDirection: 'row', height: 25, backgroundColor: "#dcdcdc", display: "flex", flexDirection: "row" },
    detials: { width: "100%", alignContent: "center", flexDirection: 'row', height: 25, display: "flex", flexDirection: "row" },
    CardHeader: {
      flexDirection: "column",
      fontSize: 18,
      fontWeight: "400",
      color: "#FF0000",
      display: "flex",
      margin: 15
    },
    separator: {
      height: 1,
      width: "100%",
      backgroundColor: "#FF0000",
      alignSelf: "center",
      marginBottom: 15,
    },
    InfoDescriptionText: {
      width: "50%",
      color: "#003366",
      flexDirection: "row",
      fontSize: 15,
      fontWeight: "700"
      , marginBottom: 0

    },
    InfoText: {
      color: "#003366",
      flexDirection: "row",
      fontSize: 15,
      fontWeight: "300"
      , marginBottom: 0
    },

  });

  const [state, setstate] = useState({
    size: "",
    type: "",
    location: "",
    typeOfProperty: false,
    additionalNotes: "",
    price: "",
    seller: {
      ownername: "",
      company: "",
      number: "",
      investor: false,
      email: "",
    },
  });

  const columns = [
    { title: "Company", field: "businessName", initialEditValue: "" },
    { title: "Area", field: "address.description", initialEditValue: "" },
    { title: "Property Type", field: "typeOfProperty", initialEditValue: "" },

    {
      title: "Property Size",
      field: "sizeMax",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.sizeMax : "Hidden for Demo",
    },
    { title: "Type", field: "type", initialEditValue: "" },
    {
      title: "Notes",
      field: "notes",
      editable: "onAdd",
      render: (rowData) =>
        features.AllowCriticalEditsAdmin ? rowData.notes : "Hidden for Demo",
    },

    // {
    //   title: language.account_approve,
    //   field: "practiceAdminActiveStatus",
    //   type: "boolean",
    //   initialEditValue: true,
    // },
  ];

  const [filterstate, setFilterState] = useState({
    startDate: "",
    endDate: "",
    sizeRangeMin: "",
    sizeRangeMax: "",
    type: "",
    Proptype: ""
  });



  //Functions


  function renderTable() {
    return <Row>
      <MaterialTable
        title={"Enquiries"}
        columns={columns}
        data={equiries}
        options={{
          exportButton: true,
          sorting: true,
          actionsColumnIndex: -1,
        }} />
    </Row>;
  }

  function renderFlatlist() {
    return <Row>
      <FlatList
        keyExtractor={(item, index) => {
          return index.toString();
        }}
        list={equiries}
        renderItem={renderItem}
        renderWhenEmpty={() => <div>There currently is no Enquiries!</div>} />
    </Row>;
  }

  const typeSelect = (type) => {
    console.log("type", type);
    setstate({
      ...state,
      type: type,
    });
  };

  const saveData = (location, data) => {
    setstate({
      ...state,
      [location]: data
    })
  };

  const saveFilter = (filter, inFos) => {
    console.log("inFos", filter, inFos)
    setFilterState({
      ...filterstate,
      [filter]: inFos
    })
  };

  const ResetFilter = () => {
    setEquiries(enquiriesReducer);
    alert(`Filter Removed`);
    setisFiltered(false);
  };

  useEffect(() => {
    if (enquiriesReducer) {
      setEquiries(enquiriesReducer);
    }
  }, [enquiriesReducer]);

  const filter = () => {
    console.log('type', filterstate);

    let filtered = [];
    let error = false;
    if (filterstate) {
      if (parseInt(filterstate.sizeRangeMin) > parseInt(filterstate.sizeRangeMax)) {
        alert("Min Filter Size can not be greater than max size");
      } else {
        if (!filterstate.sizeRangeMin !== "" &&
          !filterstate.sizeRangeMin !== null &&
          !filterstate.sizeRangeMax !== "" &&
          !filterstate.sizeRangeMax !== null
        ) {
          if (filterstate.type) {
            if (filterstate.Proptype) {
              equiries.map((enquiry) => {

                if (
                  ((filterstate.sizeRangeMin <= parseInt(enquiry.sizeRangeMin) && parseInt(enquiry.sizeRangeMin) <= filterstate.sizeRangeMax) ||
                    (filterstate.sizeRangeMin <= parseInt(enquiry.sizeMax) && parseInt(enquiry.sizeMax) <= filterstate.sizeRangeMax)) && (
                    enquiry.type === filterstate.type) && (enquiry.typeOfProperty
                      === filterstate.Proptype)
                ) {
                  filtered.push(enquiry);
                }
              });
            } else {
              error = true;
              alert("Please Select if you what type of property you want to look for");
            }
          } else {
            error = true;
            alert("Please Select if you looking  for Renting or Buying");
          }
        } else {
          error = true;
          alert("Please select a Size Range");
        }


        if (!error) {

          setisFiltered(true);
          setEquiries(filtered)
          alert(`Filter Set \n Number of Enquiries: ${filtered.length}`);
        }
      }
    } else {
      alert("Please enter search options!");
    }
  };

  function numberWithSpaces(x) {
    if (x) {
      let numbers = x.replace(/\D/g, '');
      var parts = numbers.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return parts.join(".");
    }
  }

  function GetAddress(x) {
    var index = x.indexOf(",");
    let Address = x.substring(0, index);
    return Address;
  }

  const styles = useStyles();
  const renderItem = (item) => {
    return (
      <Col md="4">
        <Card
          className="card-chart"
          style={{
            minWidth: "275",
            border: "3px solid",
            borderColor: "#399ddb",
            borderRadius: 30,

          }}
        >
          <CardHeader
          // style={{
          //   fontSize: 25,
          //   fontWeight: '1000',
          //   margin: "10px 0 0 1px",
          //   color: "#f00000"
          // }}
          >
            {/* <h5 className="card-category">Reviews</h5> */}
            <CardTitle
              tag="h2"
              style={{
                fontSize: 30,
                fontWeight: "1000",
                margin: "10px 0 0 1px",
                color: "#f00000",
              }}
            >
              To Let/ Buy
            </CardTitle>

            <UncontrolledDropdown>
              <DropdownToggle
                className="btn-round btn-icon"
                color="default"
                outline
              // style={{marginRight: spacing + 'em'}}
              >
                <i className="now-ui-icons design_bullet-list-67" />
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem>Share</DropdownItem>
                <DropdownItem>Update</DropdownItem>
                <DropdownItem>Archive</DropdownItem>
                <DropdownItem>Unachive</DropdownItem>
                <DropdownItem>Pull Forward</DropdownItem>
                <DropdownItem>Call Client</DropdownItem>
                <DropdownItem>Message Client</DropdownItem>
                <DropdownItem className="text-danger">
                  Share Internally
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </CardHeader>


          <CardBody>
            <Row mb="12">
              <Col md="12">
                <FormGroup style={{
                  fontSize: 15,
                  fontWeight: '400',
                  margin: "10px 0 0 1px",
                  color: "#0b042e"
                }}>
                  <span
                    style={{
                      fontSize: 18,
                      fontWeight: '1000',
                      margin: "10px 0 0 1px",
                      color: "#0b042e"
                    }}
                  >
                    Company: </span>
                  {/* <p className="description">{Booking.serviceType}</p> */}
                  {item?.CompanyName}{" "}
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    margin: "10px 0 0 1px",
                    color: "#0b042e",
                  }}
                >
                  <span
                    style={{
                      fontSize: 18,
                      fontWeight: "600",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    Area: </span>
                  {(item?.address?.suburb ? item?.address?.suburb : "N/A")}


                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    margin: "10px 0 0 1px",
                    color: "#0b042e",
                  }}
                >
                  <span
                    style={{
                      fontSize: 18,
                      fontWeight: "600",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    Property Type:{" "}
                  </span>
                  {/* <p className="description">{Booking.eventDate}</p> */}
                  {item.typeOfProperty}{" "}
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    margin: "10px 0 0 1px",
                    color: "#0b042e",
                  }}
                >
                  <span
                    style={{
                      fontSize: 18,
                      fontWeight: "600",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    Property Size:{" "}
                  </span>
                  {/* <p className="description">{Booking.eventDate}</p> */}
                  {item.sizeMin} - {item.sizeMax}㎡
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    margin: "10px 0 0 1px",
                    color: "#0b042e",
                  }}
                >
                  <span
                    style={{
                      fontSize: 18,
                      fontWeight: "600",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    To Let/ For Sale:{" "}
                  </span>
                  {/* <p className="description">{Booking.eventDate}</p> */}
                  {item.type}
                </FormGroup>
              </Col>
              <Col md="12">
                <FormGroup
                  style={{
                    fontSize: 15,
                    fontWeight: "400",
                    margin: "10px 0 0 1px",
                    color: "#0b042e",
                  }}
                >
                  <span
                    style={{
                      fontSize: 18,
                      fontWeight: "600",
                      margin: "10px 0 0 1px",
                      color: "#0b042e",
                    }}
                  >
                    Notes: {" "}</span>
                  {/* <p className="description">{Booking.eventDate}</p> */}
                  {item.notes}
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
          <CardFooter>
            <Button
              color="primary"
              onClick={() => {
                navigate("/staffenquirydetails", { state: { item } });
              }}
            >
              View
            </Button>
          </CardFooter>
        </Card>
      </Col>
    );
  };

  const renderPropertyInfoCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "100%",
          maxWidth: "600px",
          margin: "auto",
          borderRadius: "8px",
          boxShadow: "0 5px 9px rgb(97, 158, 197)",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Enquiry Information
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={12}>
                <FormText color="white" tag="span" >
                  Size:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("size", value.target.value)
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Building size"
                // style={{ borderRadius: '4px', borderColor: '#ced4da' }}
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Type of property:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("typeOfProperty", value.target.value)
                  }}
                  fullWidth
                  type="select"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  placeholder="Select an item..."
                >
                  <option>Warehouse</option>
                  <option>Workshop</option>
                  <option>Mini Factory</option>
                  <option>Factory</option>
                  <option>Storage Unit</option>
                  <option>Investment</option>
                  <option>Industrial Yard</option>
                  <option>Vacant Land</option>
                  <option>Showroom</option>
                  <option>Retail</option>
                  <option>Office</option>
                  <option>Restaurant</option>
                  <option>Hotel</option>
                  <option>Guesthouse</option>
                  <option>Medical Suite</option>
                  <option>Business Centre</option>
                  <option>Service Station</option>
                  <option>Small Holding</option>
                  <option>Full Floor</option>
                  <option>Business</option>
                  <option>Building</option>
                </Input>
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Area:
                </FormText>

                <GoogleMapsAutoComplete
                  onChange={(value) => {
                    saveData("address", value)
                  }}
                  className={styles.input}
                  placeholder="Find your Area"
                />
              </GridItem>


              <GridItem xs={12}>
                <FormGroup>
                  <FormText color="white" tag="span" style={{ display: 'block', marginBottom: '16px' }}>
                    Type:
                  </FormText>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <Label check className={styles.radioText} style={{ color: "white", display: 'flex', alignItems: 'center' }}  >
                      <Input type="radio" name="radio1" className={styles.radioButton} onChange={() => setData("type", "sale")} />
                      <span style={{ marginLeft: '8px' }}>To Buy</span>
                    </Label>
                    <Label check className={styles.radioText} style={{ color: "white", display: 'flex', alignItems: 'center' }}>
                      <Input type="radio" name="radio1" className={styles.radioButton} onChange={() => setData("type", "tolet")} />
                      <span style={{ marginLeft: '8px' }}>To let</span>
                    </Label>
                    <Label check className={styles.radioText} style={{ color: "white", display: 'flex', alignItems: "center" }}>
                      <Input type="radio" name="radio1" className={styles.radioButton} onChange={() => setData("type", "both")} />
                      <span style={{ marginLeft: '8px' }}>Both</span>
                    </Label>
                  </div>
                </FormGroup>
              </GridItem>

              {filterstate.type && filterstate.type !== "both" ? (
                <>
                  {/* <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      {state.type === "sale" ? "Sale Price" : "GROSS RENTAL"}
                    </FormText>
                    <Input
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder={
                        state.type === "sale" ? "Sale Price" : "GROSS RENTAL"
                      }
                    />
                  </GridItem> */}


                  {/* <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      Deposit:
                    </FormText>
                    <Input
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="Deposit Price"
                    />
                  </GridItem> */}
                  {/* </>
              ) : state.type ? (
                <>
                  <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      Sale Price
                    </FormText>
                    <Input
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="Sale Price"
                    />
                  </GridItem> */}

                  {/* <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      Deposit:
                    </FormText>
                    <Input
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="Deposit Price"
                    />
                  </GridItem> */}

                  {/* <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      GROSS RENTAL
                    </FormText>
                    <Input
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="GROSS RENTAL"
                    />
                  </GridItem> */}
                  {/* <GridItem xs={6}>
                    <FormText color="white" tag="span">
                      Deposit:
                    </FormText>
                    <Input
                      fullWidth
                      type="text"
                      className={styles.input}
                      placeholder="Deposit Price"
                    />
                  </GridItem> */}
                </>
              ) : null}

              {state.type ? (
                <>
                  {/* <GridItem xs={12}>
                    <FormText color="white" tag="span">
                      Available from:
                    </FormText>
                    <Input
                      fullWidth
                      type="date"
                      className={styles.input}
                      placeholder="Deposit Price"
                    />
                  </GridItem> */}
                  {state.type === "tolet" || state.type === "both" ? (
                    <>
                      {/* <GridItem xs={12}>
                        <FormText color="white" tag="span">
                          Lease Period:
                        </FormText>
                        <Input
                          fullWidth
                          type="select"
                          style={{
                            borderWidth: 2,
                            borderColor: "#f00000",
                            backgroundColor: "white",
                            color: "grey",
                          }}
                          placeholder="Select an item..."
                        >
                          <option>Negotiable</option>
                          <option>2 months</option>
                          <option>4 month</option>
                          <option>6 months</option>
                          <option>8 months</option>
                          <option>10 months</option>
                          <option>1 year</option>
                          <option>2 years</option>
                          <option>3 years</option>
                          <option>4 years</option>
                          <option>5 years plus</option>
                        </Input>
                      </GridItem> */}
                    </>
                  ) : null}
                </>
              ) : null}
              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Notes:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("additionalNotes", value.target.value)
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="Notes"
                />
              </GridItem>
              {/* 
              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Type of Title:
                </FormText>
                <Input
                  fullWidth
                  type="select"
                  style={{
                    borderWidth: 2,
                    borderColor: "#f00000",
                    backgroundColor: "white",
                    color: "grey",
                  }}
                  placeholder="Select an item..."
                >
                  <option>Freehold</option>
                  <option>Sectional Title</option>
                  <option>None</option>
                  <option>Share Block</option>
                </Input>
              </GridItem> */}
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  const renderSellerInfoCard = () => {
    return (
      <Card
        style={{
          backgroundColor: "#399ddb",
          width: "100%",
          height: "100%",
          borderRadius: "8px",
          boxShadow: "0 5px 9px rgb(97, 158, 197)",
        }}
      >
        <CardHeader>
          <CardTitle tag="h4" style={{ color: "white" }}>
            Enquiry Requested Details
          </CardTitle>
        </CardHeader>
        <CardBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Owner:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("OwnerName", value.target.value)
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="Owner name"

                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Company:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("CompanyName", value.target.value)
                  }}
                  fullWidth
                  type="text"
                  className={styles.input}
                  placeholder="Company name"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Number:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("PhoneNumber", value.target.value)
                  }}
                  fullWidth
                  type="number"
                  className={styles.input}
                  placeholder="Phone number"
                />
              </GridItem>

              <GridItem xs={12}>
                <FormText color="white" tag="span">
                  Email:
                </FormText>
                <Input
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("Email", value.target.value)
                  }}
                  fullWidth
                  type="email"
                  className={styles.input}
                  placeholder="Email"
                />
              </GridItem>
            </GridContainer>
          </GridItem>
        </CardBody>
      </Card>
    );
  };

  // const renderMediaCaptureCard = () => {
  //   return (
  //     <Card
  //       style={{
  //         backgroundColor: "#399ddb",
  //         width: "100%",
  //         height: "100%",
  //       }}
  //     >
  //       <CardHeader>
  //         <CardTitle tag="h4" style={{ color: "white" }}>
  //           Property Owner Details
  //         </CardTitle>
  //       </CardHeader>
  //       <CardBody>
  //         <GridItem xs={12} sm={12} md={12} lg={12}>
  //           <GridContainer spacing={1}>
  //             <GridItem xs={6}>
  //               <Input fullWidth type="image" placeholder="Owner name" />
  //             </GridItem>

  //             <GridItem xs={6}>
  //               <Input
  //                 fullWidth
  //                 type=""
  //                 className={styles.input}
  //                 placeholder="Select an item..."
  //               />
  //             </GridItem>
  //           </GridContainer>
  //         </GridItem>
  //       </CardBody>
  //     </Card>
  //   );
  // };

  const renderModal = () => {
    return (
      <Modal
        isOpen={isOpen}
        toggle={() => setIsOpen(false)}
        centered={true}
        size="xl"
      >
        <ModalHeader>Create Enquiry</ModalHeader>
        <ModalBody>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer spacing={1}>
              <GridItem lg={6}>{renderPropertyInfoCard()}</GridItem>

              <GridItem lg={6}>{renderSellerInfoCard()}</GridItem>

              {/* <GridItem lg={12}>{renderMediaCaptureCard()}</GridItem> */}
            </GridContainer>
          </GridItem>
        </ModalBody>
        <ModalFooter>
          <Button

            onClick={filter}

          >
            Create Enquiry</Button>

          <Button
            style={{
              backgroundColor: "#ff000f",
              height: 45,
            }}>
            Cancel

          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  return (
    <>
      <Row>
        <Card style={{
          backgroundColor: "#399ddb",
          width: "100%",
          height: "20%",
        }}>
          <CardHeader>
            <CardTitle tag="h4" style={{ color: "white" }}>Filter</CardTitle>
          </CardHeader>
          <CardBody>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <GridContainer spacing={1}>

                <GridItem xs={6}>
                  <FormText color="white" tag="span"
                  >
                    Rent or Buy :
                  </FormText>

                  <Input
                    fullWidth
                    type="select"
                    style={{
                      borderWidth: 2,
                      borderColor: "#f00000",
                      backgroundColor: "white",
                      color: "grey",
                    }}

                    onChange={(value) => {
                      saveFilter("type", value.target.value)
                    }}
                    value={filterstate.value}
                  >
                    <option>tolet</option>
                    <option>sale</option>
                    <option>both</option>
                  </Input>


                </GridItem>
                <GridItem xs={6}>
                  <FormText color="white" tag="span"
                  >
                    Property Type :
                  </FormText>
                  <Input
                    fullWidth
                    type="select"
                    style={{
                      borderWidth: 2,
                      borderColor: "#f00000",
                      backgroundColor: "white",
                      color: "grey",
                    }}
                    placeholder="Select an item..."

                    onChange={(value) => {
                      saveFilter("Proptype", value.target.value)
                    }}
                    value={filterstate.Proptype}
                  >
                    <option>Warehouse</option>
                    <option>Office</option>
                    <option>Retail</option>
                    <option>Vacant Land</option>
                    <option>Industrial Yard</option>
                    <option>Workshop</option>
                    <option>Restaurant</option>
                    <option>Showroom</option>
                    <option>Investment</option>
                    <option>Building</option>
                    <option>Mini Factory</option>
                    <option>Factory</option>
                    <option>Business</option>
                    <option>Hotel</option>
                    <option>Full Floor</option>
                    <option>Storage Unit</option>
                    <option>Guesthouse</option>
                    <option>Medical Suite</option>
                    <option>Business Centre</option>
                    <option>Service Station</option>
                    <option>Small Holding</option>
                  </Input>
                </GridItem>
                <GridItem xs={6}>
                  <FormText color="white" tag="span"
                  >
                    Size Min:
                  </FormText>
                  <Input
                    fullWidth
                    type="number"
                    style={{
                      borderWidth: 2,
                      borderColor: "#f00000",
                      height: 35,
                      backgroundColor: "white",
                      fontSize: 16,
                      paddingHorizontal: 10,
                      paddingVertical: 8,
                      borderRadius: 8,
                      color: "grey",
                      paddingRight: 30,
                    }}
                    placeholder="min size"

                    onChange={(value) => {
                      saveFilter("sizeRangeMin", value.target.value)
                    }}
                    value={filterstate.size}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <FormText color="white" tag="span"
                  >
                    Size Max :
                  </FormText>
                  <Input

                    fullWidth
                    type="number"
                    style={{
                      borderWidth: 2,
                      borderColor: "#f00000",
                      height: 35,
                      backgroundColor: "white",
                      fontSize: 16,
                      paddingHorizontal: 10,
                      paddingVertical: 8,
                      borderRadius: 8,
                      color: "grey",
                      paddingRight: 30,
                    }}
                    placeholder="max size"

                    onChange={(value) => {
                      saveFilter("sizeRangeMax", value.target.value)
                    }}
                    value={filterstate.value}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <FormText color="white" tag="span"
                  >
                    From Date :
                  </FormText>
                  <Input
                    style={{
                      borderWidth: 2,
                      borderColor: "#f00000",
                      height: 35,
                      backgroundColor: "white",
                      fontSize: 16,
                      paddingHorizontal: 10,
                      paddingVertical: 8,
                      borderRadius: 8,
                      color: "grey",
                      paddingRight: 30,
                    }}
                    fullWidth
                    type="date"

                    onChange={(value) => {
                      saveFilter("startDate", value.target.value)
                    }}
                    value={filterstate.startDate}
                  />
                </GridItem>
                <GridItem xs={6}>
                  <FormText color="white" tag="span"
                  >
                    To Date :
                  </FormText>
                  <Input
                    fullWidth
                    type="date"
                    style={{
                      borderWidth: 2,
                      borderColor: "#f00000",
                      height: 35,
                      backgroundColor: "white",
                      fontSize: 16,
                      paddingHorizontal: 10,
                      paddingVertical: 8,
                      borderRadius: 8,
                      color: "grey",
                      paddingRight: 30,
                    }}
                    placeholder="To Date"

                    onChange={(value) => {
                      saveFilter("endDate", value.target.value)
                    }}
                    value={filterstate.endDate}
                  />
                </GridItem>



                {/* <GridItem xs={12}>
            </GridItem> */}
                {!isFiltered && (
                  <GridItem xs={6}>
                    <Button
                      style={{
                        width: 150,
                        height: 40,
                        alignSelf: "center",
                        marginTop: 1,
                        borderRadius: 5,
                        backgroundColor: "#f00000",
                        color: "white",
                      }}
                      onClick={filter}

                    >
                      Filter
                    </Button>
                  </GridItem>
                )}
                <GridItem xs={6}>
                  <Button
                    style={{
                      width: 150,
                      height: 40,
                      alignSelf: "center",
                      marginTop: 1,
                      borderRadius: 5,
                      justifyContent: "center",
                      backgroundColor: "#3366",
                      color: "white",
                    }}
                    onClick={ResetFilter}
                  >
                    Reset
                  </Button>

                </GridItem>
              </GridContainer>
            </GridItem>

          </CardBody>
        </Card>
      </Row>

      <Row>
        <AddBoxRounded
          onClick={toggleTwo}
          style={{
            color: "#ff000f",
            alignItems: "right",
            width: 70,
            height: 70,
          }}
        />
        {renderModal()}
      </Row>
      <Row mb="6">

        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-end"

        >


          <Button
            style={{
              width: 150,
              height: 40,
              alignItems: "flex-end",
              alignSelf: "center",
              spacing: 20,
              marginTop: 1,
              borderRadius: 5,
              backgroundColor: "#2196F3",
              color: "white",
            }}
            onClick={() => {
              setIsCardView(true)
            }}
          >
            Card View <i className="now-ui-icons design_image" />
          </Button>




          <Button
            style={{

              width: 150,
              height: 40,
              alignSelf: "center",
              alignItems: "flex-end",
              spacing: 20,
              marginTop: 1,
              borderRadius: 5,
              justifyContent: "center",
              backgroundColor: "#3366",
              color: "white",
            }}
            onClick={() => {
              setIsCardView(false)
            }}


          >
            Table View <i className="now-ui-icons files_paper" />
          </Button>

        </Grid>

      </Row>




      {isCardView ?
        (renderFlatlist())
        :
        (renderTable())}
    </>
  );

};

export default StaffEnquiries;
